import React from "react";
import PropTypes from "prop-types";

import "./CityDetail.scss";
import { Link } from "react-router-dom";

const CityDetail = props => {
  const {
    display,
    updateStatus,
    disableStatus,
    id,
    name,
    code,
    skey,
    currYear,
    purpose,
    is_active,
    is_complete,
    preventAdvance,
    hideGoto,
    inDashboard,
    advanceGameMessage,
    color
  } = props;

  return (
    <div className={`${display || !is_complete ? "active" : "hidden"}`}>
      <div className={`game__container`}>
        {/* <div className={`container gameDetails__container`}> */}
        <div className={`game__color`} style={{ backgroundColor: `${color}` }} />
        <div className="container flex flex-auto">
          <div className={`gameId`}>{id}.</div>
          <div className={`gameName`}>{name}</div>
        </div>

        <div className="container flex flex-auto">
          <span className="gameInfo container" style={{ marginRight: "10px" }}>
            Code:
          </span>
          <span className="gameInfo container" style={{ color: "#5399C9" }}>
            <strong>{code}</strong>
          </span>
        </div>

        <div className="container flex flex-auto">
          <span className="gameInfo container" style={{ marginRight: "10px" }}>
            Purpose:
          </span>
          <span className="gameInfo container" style={{ color: "#5399C9" }}>
            <strong>{purpose}</strong>
          </span>
        </div>

        <div className="container flex flex-auto">
          <span className="gameInfo container" style={{ marginRight: "10px" }}>
            Starting Year:
          </span>
          <span className="gameInfo container" style={{ color: "#5399C9" }}>
            <strong>2020</strong>
          </span>
        </div>

        <div className="container flex flex-auto">
          <span className="gameInfo container" style={{ marginRight: "10px" }}>
            Current Year:
          </span>
          <span className="gameInfo container" style={{ color: "#5399C9" }}>
            {!currYear ? <strong>2020</strong> : <strong>{currYear}</strong>}
          </span>
        </div>
        <div className="joinGame flex flex-align-center">
          <button
            className={advanceGameMessage.includes(parseInt(id)) ? "disabledAdvanceButton" : "submit"}
            id={id}
            name={name}
            skey={skey}
            onClick={e => preventAdvance(e)}
          >
            {advanceGameMessage.includes(parseInt(id)) ? "Advancing..." : "Advance Game"}
          </button>
        </div>

        {/* </div> */}

        {is_complete ? (
          <div className="container flex flex-align-center">
            <h4>Completed</h4>
          </div>
        ) : (
          <div className="container flex flex-align-center">
            <input
              className={`tgl tglSkewed`}
              id={`cb3-${id}`}
              type="checkbox"
              onClick={e => updateStatus(e, id)}
              checked={is_active}
              readOnly
            />
            <label
              className={`tglBtn ${disableStatus && "tglDisabled"}`}
              data-tg-off="Inactive"
              data-tg-on="Active"
              htmlFor={`cb3-${id}`}
            />
          </div>
        )}
        {inDashboard ? null : (
          <div className="joinGame flex flex-align-center">
            {!hideGoto && (
              <Link to={`/instructor/city/${skey}`}>
                <button className="dashboard">Dashboard</button>
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

CityDetail.propTypes = {
  display: PropTypes.bool.isRequired,
  updateStatus: PropTypes.func.isRequired,

  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  skey: PropTypes.string.isRequired,
  purpose: PropTypes.string.isRequired,
  is_active: PropTypes.bool.isRequired,
  is_complete: PropTypes.bool.isRequired,

  disableStatus: PropTypes.bool,
  hideGoto: PropTypes.bool
};

export default CityDetail;
